import { render, staticRenderFns } from "./SessionDetailQuestionsList.vue?vue&type=template&id=70af25cc&"
import script from "./SessionDetailQuestionsList.vue?vue&type=script&lang=js&"
export * from "./SessionDetailQuestionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports